<template>
  <v-container class="my-5">
    <v-row justify="center" v-if="loading">
      <v-progress-circular indeterminate color="indigo" />
    </v-row>

    <v-tabs
      v-model="selectedTab"
      fixed-tabs
      background-color="indigo darken-3"
      dark
      class="elevation-2 rounded-lg"
    >
      <v-tab
        v-for="(server, index) in fileServers"
        :key="server.id"
        :href="`#tab-${index}`"
        class="d-flex align-center tab-hover"
        :class="{ 'tab-active': selectedTab === `tab-${index}` }"
      >
        <v-icon left>mdi-server-network</v-icon>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ server.name }}</span>
          </template>
          <span
            >Server {{ index + 1 }}: {{ server.description || 'No description available' }}</span
          >
        </v-tooltip>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab" class="p-3">
      <v-tab-item
        v-for="(server, index) in fileServers"
        :key="server.id"
        :value="`tab-${index}`"
        class="elevation-1 rounded-lg pa-4"
        transition="fade-transition"
      >
        <AssetDicomUpload :server="server" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import AssetDicomUpload from '@/modules/asset/views/AssetDicomUpload.vue';
import { FileServer } from '@/modules/fileServer/api';

export default {
  name: 'AssetUploadBuilder',
  components: {
    AssetDicomUpload,
  },
  data() {
    return {
      selectedTab: null,
      fileServers: [],
      loading: true,
    };
  },
  async created() {
    await this.fetchFileServers();
  },
  methods: {
    async fetchFileServers() {
      try {
        const { data: rawFileServers } = await FileServer.all();
        this.fileServers = rawFileServers.map((fileServerTmp, idx) => ({
          ...fileServerTmp,
          id: idx,
        }));
        if (this.fileServers.length > 0) {
          this.selectedTab = `tab-0`;
        }
      } catch (error) {
        console.error('Error fetching file servers:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-tabs .v-tab {
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.tab-hover:hover {
  background-color: #5c6bc0;
  transform: scale(1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.tab-active {
  background-color: #00405e !important;
  color: white !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.v-tabs-items .v-tab-item {
  background-color: #f9f9f9;
  border-radius: 20px;
  transition: all 0.3s ease;
}
.v-tabs--fixed-tabs > .v-tabs-bar .v-tab {
  flex: 1 1 auto;
  width: 100%;
  border: 1px solid #ffffff;
}
</style>
